import SituacaoFuncionalList from './list';

export default function SituacaoFuncionalPage() {
  return <SituacaoFuncionalList />;
}
